import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import {
  bulkDeleteInstrumentsFailure,
  bulkDeleteInstrumentsRequest,
  bulkDeleteInstrumentsSuccess,
  fetchInstrumentsFailure,
  fetchInstrumentsStart,
  fetchInstrumentsSuccess,
} from "../../../store/features/customer/instruments/instrumentsSlice";

const URL = buildApiUrl("/api/v1/instruments/instrument/");

const getInstrumentssApi = async (accessToken, filter = "") => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        search: filter || null,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchInstrumentsSaga(action) {
  try {
    const { accessToken, search } = action.payload || {};
    const sensorsData = yield call(getInstrumentssApi, accessToken, search);
    yield put(fetchInstrumentsSuccess(sensorsData));
  } catch (error) {
    yield put(fetchInstrumentsFailure(error.message));
  }
}

const bulkDeleteInstrumentsApi = async ({ accessToken, instrumentsIds }) => {
  try {
    const response = await axios.delete(`${URL}bulk_delete/`, {
      headers: getAuthHeaders(accessToken),
      data: {
        instruments: instrumentsIds,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleBulkDeleteInstrumentsSaga(action) {
  try {
    const { accessToken, instrumentsIds } = action.payload;
    yield call(bulkDeleteInstrumentsApi, { accessToken, instrumentsIds });
    yield put(bulkDeleteInstrumentsSuccess(instrumentsIds));
    yield put(fetchInstrumentsStart({ accessToken }));
  } catch (error) {
    yield put(bulkDeleteInstrumentsFailure(error));
  }
}

export default function* instrumentsSaga() {
  yield takeLatest(fetchInstrumentsStart.type, fetchInstrumentsSaga);
  yield takeLatest(
    bulkDeleteInstrumentsRequest.type,
    handleBulkDeleteInstrumentsSaga
  );
}
